"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataGridFooter = void 0;

var _react = _interopRequireDefault(require("react"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _Pagination = _interopRequireDefault(require("@material-ui/lab/Pagination/Pagination"));

var _Select = _interopRequireDefault(require("../../Select/Select"));

var _DataGridFooter = require("./DataGridFooter.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataGridFooter = function DataGridFooter(_ref) {
  var data = _ref.data,
      handleChangePerPage = _ref.handleChangePerPage,
      perPage = _ref.perPage,
      page = _ref.page,
      hideSelect = _ref.hideSelect,
      handleChangePage = _ref.handleChangePage,
      _ref$paginationOption = _ref.paginationOptions,
      paginationOptions = _ref$paginationOption === void 0 ? [] : _ref$paginationOption;
  return /*#__PURE__*/_react.default.createElement(_DataGridFooter.DataGridFooterView, null, Math.ceil(data.length / perPage) > 1 ? /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    count: Math.ceil(data.length / perPage),
    page: page,
    showFirstButton: true,
    showLastButton: true,
    classes: {
      root: "text-primary"
    },
    shape: "rounded",
    onChange: handleChangePage
  }) : /*#__PURE__*/_react.default.createElement("div", null), hideSelect ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: "select-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pagination"
  }, "Rows per page: "), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Select.default, {
    value: perPage,
    background: "none",
    options: paginationOptions.map(function (option) {
      return {
        value: option,
        label: option
      };
    }),
    IconComponent: _ExpandMore.default,
    onChange: handleChangePerPage
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "pagination"
  }, (page - 1) * perPage + 1, "-", data.length > perPage ? page * perPage : data.length, " of", " ", data.length)));
};

exports.DataGridFooter = DataGridFooter;

//# sourceMappingURL=DataGridFooter.js.map